import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProductFormLayer from "../components/ProductFormLayer";

const ProductFormPage = () => {
  return (
    <>
      <MasterLayout>
        <ProductFormLayer />
      </MasterLayout>
    </>
  );
};

export default ProductFormPage;
